import type { IntlShape } from 'react-intl';

const renderAutoCompleteLocaleText = (intl: IntlShape) => {
  return {
    clearText: intl.formatMessage({ id: 'autocomplete.clearText', defaultMessage: 'Temizle' }),
    closeText: intl.formatMessage({ id: 'autocomplete.closeText', defaultMessage: 'Kapat' }),
    loadingText: intl.formatMessage({ id: 'autocomplete.loadingText', defaultMessage: 'Yükleniyor...' }),
    noOptionsText: intl.formatMessage({ id: 'autocomplete.noOptionsText', defaultMessage: 'Kayıt bulunamadı' }),
    openText: intl.formatMessage({ id: 'autocomplete.openText', defaultMessage: 'Aç' }),
  };
};

export default renderAutoCompleteLocaleText;
